import styled, { css } from 'styled-components';
import sendIcon from 'images/icons/send.svg';
import bookmarkIcon from 'images/icons/bookmark.svg';
import sendIconWhite from 'images/icons/send_white.svg';
import bookmarkIconWhite from 'images/icons/bookmark_white.svg';

const iconMap = {
  send: sendIcon,
  bookmark: bookmarkIcon,
  sendWhite: sendIconWhite,
  bookmarkWhite: bookmarkIconWhite,
};

const backgroundIconFill = icon => css`
  background: url('${iconMap[icon]}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`;

export const SendIcon = styled.div`
  width: 10px;
  height: 12px;
  opacity: ${({ selected }) => selected ? 1 : 0.7};
  ${backgroundIconFill('sendWhite')};
`;

export const BookmarkIcon = styled.div`
  width: 12px;
  height: 16.5px;
  opacity: ${({ selected }) => selected ? 1 : 0.7};
  ${backgroundIconFill('bookmarkWhite')};
`;
